<template>
  <component-wrapper class="i-frame-fi">
    <grid-container-fi v-if="isMounted">
      <div class="fi-col-start-1 fi-col-end-13 md:fi-col-start-2 md:fi-col-end-12">
        <iframe
          v-if="fields?.source?.value"
          ref="iFrame"
          width="100%"
          :height="customHeight"
          :src="fields.source.value"
          :title="fields?.iframeTitle?.value || fields.source.value"
          :onload="resizeIframe"
        />
      </div>
    </grid-container-fi>

    <loading-indicator
      v-else
      variant="spinnerLocal"
    />
  </component-wrapper>
</template>

<script setup lang="ts">
import iframeResize from '@iframe-resizer/parent';
import { LoadingIndicator } from 'atoms';
import { computed, onMounted, ref, useTemplateRef } from 'vue';

import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import { useFields } from '@/composables/fields';
import { useFischer } from '@/composables/fischerPlugin';

defineOptions({ name: 'IFrameFi' });

const fischer = useFischer();
const fields = useFields('IFrameFiFields');

const isMounted = ref(false);
const iFrame = useTemplateRef<HTMLIFrameElement>('iFrame');

const customHeight = computed(() => fields.iframeHeight?.value || undefined);

function resizeIframe() {
  if (iFrame.value) {
    iframeResize(
      {
        log: false, // Enable console logging
        direction: 'vertical',
        inPageLinks: true,
        waitForLoad: false, // we handle onload ourself
        license: '1jy4dww5qzv-s54r73oxcn-v59f4kfgfz',
        warningTimeout: APP_ENVIRONMENT !== 'PROD' || fischer.isCM() ? 5000 : 0,
      },
      iFrame.value,
    );
  } else {
    console.error('missing iframe for resizer');
  }
}

onMounted(() => {
  isMounted.value = true;
});
</script>

<style scoped src="./i-frame-fi" />
